import {
  REQUEST_VIDEO_DEVICES,
  RESPONSE_VIDEO_DEVICES,
  REQUEST_VIDEO_DEVICES_FAILURE,
  REQUEST_VIDEO_DEVICE_CREATE,
  RESPONSE_VIDEO_DEVICE_CREATE,
  REQUEST_VIDEO_DEVICE_CREATE_FAILURE,
  REQUEST_VIDEO_DEVICE_DELETE,
  RESPONSE_VIDEO_DEVICE_DELETE,
  REQUEST_VIDEO_DEVICE_DELETE_FAILURE,
} from "../actions/videoDevicesActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  videoDevicesDataState: queriesStates.NOT_REQUESTED,
  videoDeviceCreateDataState: queriesStates.NOT_REQUESTED,
  videoDeviceDeleteDataState: queriesStates.NOT_REQUESTED,
  videoDevices: [],
  errors: [],
};

const videoDevicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_VIDEO_DEVICES: {
      return Object.assign({}, state, {
        videoDevicesDataState: queriesStates.REQUEST,
      });
    }
    case RESPONSE_VIDEO_DEVICES: {
      return Object.assign({}, state, {
        videoDevicesDataState: queriesStates.READY,
        videoDevices: action.data.videoDeviceIntegrations,
      });
    }
    case REQUEST_VIDEO_DEVICES_FAILURE: {
      return Object.assign({}, state, {
        videoDevicesDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_VIDEO_DEVICE_CREATE: {
      return Object.assign({}, state, {
        videoDeviceCreateDataState: queriesStates.REQUEST,
      });
    }
    case RESPONSE_VIDEO_DEVICE_CREATE: {
      return Object.assign({}, state, {
        videoDeviceCreateDataState: queriesStates.READY,
        videoDevices: state.videoDevices.map((x) => {
          if (x.id === action.howenDeviceId) {
  
            x.unit = action.unit;
          }

          return x;
        }),
      });
    }
    case REQUEST_VIDEO_DEVICE_CREATE_FAILURE: {
      return Object.assign({}, state, {
        videoDeviceCreateDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_VIDEO_DEVICE_DELETE: {
      return Object.assign({}, state, {
        videoDeviceDeleteDataState: queriesStates.REQUEST,
      });
    }
    case RESPONSE_VIDEO_DEVICE_DELETE: {
      return Object.assign({}, state, {
        videoDeviceDeleteDataState: queriesStates.READY,
        videoDevices: state.videoDevices.map((x) => {
          if (x.id === action.howenDeviceId) {
      
            x.unit = null;
          }

          return x;
        }),
      });
    }
    case REQUEST_VIDEO_DEVICE_DELETE_FAILURE: {
      return Object.assign({}, state, {
        videoDeviceDeleteDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    default:
      return state;
  }
};

export default videoDevicesReducer;
